import { useNavigate } from "react-router-dom";
import { ChevronDown, Zap } from "lucide-react";

export function HomeHero() {
  const navigate = useNavigate();
  return (
    <section
      className="relative py-16 sm:py-28 px-4 overflow-hidden"
      style={{
        backgroundImage: `url(https://images.unsplash.com/photo-1764136093763-3f571bb2cf7e?crop=entropy&cs=srgb&fm=jpg&q=85)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      data-testid="hero-section"
    >
      <div
        className="absolute inset-0"
        style={{ background: "linear-gradient(135deg, rgba(8,14,26,0.92) 0%, rgba(13,92,58,0.75) 50%, rgba(8,14,26,0.92) 100%)" }}
      />
      <div
        className="absolute pointer-events-none"
        style={{
          top: "10%", right: "15%",
          width: 500, height: 500,
          background: "radial-gradient(circle, rgba(16,185,129,0.12) 0%, transparent 70%)",
          filter: "blur(50px)",
        }}
      />
      <div className="relative max-w-6xl mx-auto text-center text-white">
        <div
          className="inline-flex items-center gap-2 px-4 py-1.5 mb-6 text-xs font-semibold tracking-widest uppercase rounded-full"
          style={{
            background: "rgba(234,179,8,0.12)",
            border: "1px solid rgba(234,179,8,0.28)",
            color: "#FACC15",
            backdropFilter: "blur(8px)",
          }}
        >
          <Zap style={{ width: 12, height: 12 }} />
          Australia's Election Guide 2026
        </div>
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter mb-5 leading-[1.0]" style={{ fontFamily: "Outfit, sans-serif" }}>
          Know Your Vote.
        </h1>
        <p className="text-lg sm:text-xl font-normal mb-10 max-w-2xl mx-auto leading-relaxed" style={{ color: "rgba(255,255,255,0.78)", fontFamily: "Public Sans, sans-serif" }}>
          AI-powered party guides, policy comparisons, fact checking, and live polls — everything you need for election season.
        </p>
        <div className="flex flex-wrap gap-4 justify-center">
          <button
            data-testid="explore-parties-btn"
            onClick={() => document.getElementById("party-explorer")?.scrollIntoView({ behavior: "smooth" })}
            className="px-8 py-3.5 font-semibold text-base rounded-xl transition-all hover:-translate-y-0.5 active:scale-[0.98]"
            style={{ background: "linear-gradient(135deg, #EAB308, #FACC15)", color: "#0F172A", boxShadow: "0 8px 24px rgba(234,179,8,0.30)" }}
          >
            Explore Parties
          </button>
          <button
            data-testid="quiz-hero-btn"
            onClick={() => navigate("/quiz")}
            className="px-8 py-3.5 font-semibold text-base rounded-xl border transition-all hover:-translate-y-0.5 active:scale-[0.98]"
            style={{ background: "rgba(255,255,255,0.10)", color: "#FFFFFF", border: "1px solid rgba(255,255,255,0.22)", backdropFilter: "blur(8px)" }}
          >
            Take the Quiz
          </button>
        </div>
      </div>
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <ChevronDown className="w-6 h-6" style={{ color: "rgba(255,255,255,0.4)" }} />
      </div>
    </section>
  );
}
